const Helper = {

    //general functions

    objToString(payloadObj, params) {
        if (payloadObj === undefined) return;

        if (params === undefined)
            return '';

        var str = '';
        for (var p in params) {
            for (var item in payloadObj) {
                if (params[p] == item) {
                    str += params[p] + '::' + payloadObj[item] + '\n';
                }
            }
        }

        return str;
    },
    getArrayItemsStr(arr, propertyName) {

        let str = '';
        for (let i = 0; i < arr.length; i++) {
            str += 'item_' + i + '::' + arr[i][propertyName] + '\n';
        }

        return str;
    },


    //unique functions

    getDeliveryParams(payloadObj, params) {
        if (payloadObj === undefined) return;

        var str = '';
        for (var p in params) {
            for (var item in payloadObj) {
                if (params[p] == item && item != 'products') {
                    str += params[p] + '::' + payloadObj[item] + '\n';
                }

                if ('products' == item && params[p] == 'products') {
                    str += params[p] + '::' + this.getArrayItemsStr(payloadObj.products, 'productMakat');
                }
            }
        }

        return str;
    },


};

export default Helper;
